import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { adminApi } from "@/lib/adminAuth";

export default function AdminFortuneRequests() {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(null);
  useEffect(() => { api.get("/admin/fortune-requests", adminApi()).then(({ data }) => setItems(data)); }, []);

  return (
    <div className="font-admin-body">
      <h1 className="font-admin-head text-3xl mb-6">Fal İstekleri</h1>
      <div className="admin-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-white/50 uppercase tracking-wider">
            <tr className="border-b border-[#27272A]">
              <th className="p-3">Zaman</th><th className="p-3">Tür</th><th className="p-3">Kullanıcı</th><th className="p-3">Durum</th><th className="p-3">Model</th><th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="border-b border-[#18181B]" data-testid={`fr-${r.id}`}>
                <td className="p-3 text-xs text-white/60">{new Date(r.created_at).toLocaleString("tr-TR")}</td>
                <td className="p-3 capitalize">{r.fortune_type_slug}</td>
                <td className="p-3 font-mono text-xs">{r.user_id.slice(0, 8)}...</td>
                <td className="p-3">
                  <span className={r.status === "ready" ? "text-emerald-400" : r.status === "failed" ? "text-red-400" : "text-[#F59E0B]"}>{r.status}</span>
                </td>
                <td className="p-3 text-xs text-white/60">{r.provider_used}/{r.model_used}</td>
                <td className="p-3"><button onClick={() => setSelected(r)} className="admin-btn-ghost text-xs px-2 py-1">Görüntüle</button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-white/50">Henüz istek yok</td></tr>}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/85 p-4">
          <div className="admin-card p-6 w-full max-w-2xl max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="font-admin-head text-xl capitalize">{selected.fortune_type_slug}</h2>
              <button onClick={() => setSelected(null)} className="admin-btn-ghost text-xs px-2 py-1">Kapat</button>
            </div>
            <div className="text-xs text-white/50 mb-3">
              {new Date(selected.created_at).toLocaleString("tr-TR")} · {selected.provider_used}/{selected.model_used}
            </div>
            <pre className="whitespace-pre-wrap text-sm text-white/80 bg-white/[0.02] p-4 rounded font-admin-body">{selected.result_text || selected.error || "-"}</pre>
            <div className="text-xs text-white/50 mt-3">Payload: <code>{JSON.stringify(selected.payload)}</code></div>
          </div>
        </div>
      )}
    </div>
  );
}
